// "use client";

// import { useState, useCallback } from "react";
// import { useDispatch } from "react-redux";
// import { fetchDoctorAvailableSlotsByDate, fetchBlockedSlots } from "../../availabilityDoctor/redux/thunks/disponibilityThunks";
// import { fetchEventsByDoctor } from "../../availabilityDoctor/redux/thunks/eventsThunks";

// /* ===== Helpers ===== */

// // ─── FIX CRITIQUE : Utilise la date LOCALE, pas UTC ──────────────────────────
// // L'ancienne version (Date.UTC) produisait une date décalée selon le fuseau horaire.
// // Ex : le 29 mai à 23h en Tunisie (UTC+1) → UTC donnait "2026-05-30" → mauvaise clé.
// const utcDayKey = (dateObj) => {
//   if (!(dateObj instanceof Date)) return "";
//   return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(
//     dateObj.getDate()
//   ).padStart(2, "0")}`;
// };

// const parseAsLocal = (isoString) => {
//   if (!isoString) return null;
//   const value = String(isoString);
//   const parsed = new Date(value);
//   return Number.isNaN(parsed.getTime()) ? null : parsed;
// };

// const formatAsLocalDateTime = (date) => {
//   const pad = (value) => String(value).padStart(2, "0");
//   return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
//     date.getDate()
//   )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
//     date.getSeconds()
//   )}`;
// };

// const toMs = (isoString) => {
//   const d = parseAsLocal(isoString);
//   return d ? d.getTime() : null;
// };

// // ─── Expanse un slot parent en sous-créneaux individuels ─────────────────────
// // Ex: slot 10:00-18:00 avec slotDuration=45 → [10:00, 10:45, 11:30, ...]
// export const expandSlotToIndividual = (slot) => {
//   if (!slot?.startTime || !slot?.endTime || !slot?.slotDuration) return [];
//   const duration = Number(slot.slotDuration);
//   if (!duration || duration <= 0) return [];

//   const start = parseAsLocal(slot.startTime);
//   const end   = parseAsLocal(slot.endTime);
//   if (!start || !end || start >= end) return [];

//   const results = [];
//   let cursor = new Date(start);

//   while (cursor < end) {
//     const slotEnd = new Date(cursor.getTime() + duration * 60 * 1000);
//     if (slotEnd > end) break;
//     results.push({
//       ...slot,
//       id: `${slot.id}_${formatAsLocalDateTime(cursor)}`,
//       // Slots are compared as local wall-clock times. Serializing them to UTC
//       // here and parsing them as local again shifts every slot by the timezone.
//       startTime: formatAsLocalDateTime(cursor),
//       endTime: formatAsLocalDateTime(slotEnd),
//       isAvailable: slot.isAvailable ?? true,
//     });
//     cursor = slotEnd;
//   }
//   return results;
// };

// // ─── Vérifie si un slot est couvert par un blocage ───────────────────────────
// const isSlotCoveredByBlock = (slotStartISO, blockedSlots) => {
//   if (!blockedSlots?.length) return false;
//   const slotMs = toMs(slotStartISO);
//   if (!slotMs) return false;
//   return blockedSlots.some((b) => {
//     const bStartMs = toMs(b.startTime);
//     const bEndMs   = toMs(b.endTime);
//     if (!bStartMs || !bEndMs) return false;
//     return slotMs >= bStartMs && slotMs < bEndMs;
//   });
// };

// // ─── Vérifie si un slot chevauche un événement existant ──────────────────────
// const isSlotCoveredByEvent = (slotStartISO, slotEndISO, events) => {
//   if (!events?.length) return false;
//   const slotStartMs = toMs(slotStartISO);
//   const slotEndMs   = toMs(slotEndISO);
//   if (!slotStartMs || !slotEndMs) return false;
//   return events.some((e) => {
//     const eStartMs = toMs(e.startTime);
//     const eEndMs   = toMs(e.endTime);
//     if (!eStartMs || !eEndMs) return false;
//     return slotStartMs < eEndMs && slotEndMs > eStartMs;
//   });
// };

// // ─── Extrait les blocked slots depuis toutes les structures possibles ─────────
// const extractBlockedSlots = (blockedResult) => {
//   if (!blockedResult) return [];


//   // Format thunk : { medecinId, data: { slots: [] } }
//   if (blockedResult?.data?.slots && Array.isArray(blockedResult.data.slots))
//     return blockedResult.data.slots;

//   // Format thunk : { medecinId, data: [] }
//   if (blockedResult?.data && Array.isArray(blockedResult.data))
//     return blockedResult.data;

//   // Format direct : { slots: [] }
//   if (Array.isArray(blockedResult?.slots))
//     return blockedResult.slots;

//   // Format direct : []
//   if (Array.isArray(blockedResult))
//     return blockedResult;

//   // Format nested : { data: { data: { slots: [] } } }
//   if (blockedResult?.data?.data?.slots && Array.isArray(blockedResult.data.data.slots))
//     return blockedResult.data.data.slots;

//   if (blockedResult?.data?.data && Array.isArray(blockedResult.data.data))
//     return blockedResult.data.data;

//   // Format payload
//   if (blockedResult?.payload?.data?.slots && Array.isArray(blockedResult.payload.data.slots))
//     return blockedResult.payload.data.slots;

//   if (blockedResult?.payload?.data && Array.isArray(blockedResult.payload.data))
//     return blockedResult.payload.data;

//   if (Array.isArray(blockedResult?.payload))
//     return blockedResult.payload;

//   console.warn("🔴 extractBlockedSlots: aucun format reconnu:", JSON.stringify(blockedResult));
//   return [];
// };

// // ─── Extrait les events depuis toutes les structures possibles ────────────────
// const extractEvents = (eventsResult) => {
//   if (!eventsResult) return [];
//   if (Array.isArray(eventsResult))               return eventsResult;
//   if (Array.isArray(eventsResult.data))          return eventsResult.data;
//   if (Array.isArray(eventsResult?.data?.events)) return eventsResult.data.events;
//   if (Array.isArray(eventsResult?.events))       return eventsResult.events;
//   return [];
// };

// // ─── Filtre les events pour une date donnée ───────────────────────────────────
// const getEventsForDate = (allEvents, formattedDate) => {
//   const dayStart = parseAsLocal(`${formattedDate}T00:00:00`).getTime();
//   const dayEnd   = parseAsLocal(`${formattedDate}T23:59:59`).getTime();
//   return allEvents.filter((e) => {
//     if (!e?.startTime) return false;
//     const eStart = toMs(e.startTime);
//     const eEnd   = e.endTime ? toMs(e.endTime) : eStart;
//     return eStart <= dayEnd && eEnd >= dayStart;
//   });
// };

// // ─── Filtre les blocked slots pour une date donnée ────────────────────────────
// const getBlockedForDate = (allBlocked, formattedDate) => {
//   const dayStart = parseAsLocal(`${formattedDate}T00:00:00`).getTime();
//   const dayEnd   = parseAsLocal(`${formattedDate}T23:59:59`).getTime();
//   return allBlocked.filter((b) => {
//     if (!b?.startTime) return false;
//     const bStart = toMs(b.startTime);
//     const bEnd   = b.endTime ? toMs(b.endTime) : bStart;
//     return bStart <= dayEnd && bEnd >= dayStart;
//   });
// };

// // ─── Extrait, expanse et filtre les slots ─────────────────────────────────────
// const extractAndExpandSlots = (result, requestedDate) => {
//   if (!result) return [];
//   let rawSlots = [];
//   if (Array.isArray(result))                                rawSlots = result;
//   else if (Array.isArray(result.slots))                     rawSlots = result.slots;
//   else if (result.data && Array.isArray(result.data.slots)) rawSlots = result.data.slots;
//   else if (result.data && Array.isArray(result.data))       rawSlots = result.data;
//   const now = new Date();
//   const isToday = requestedDate === utcDayKey(now);
//   const nowMs = now.getTime();
//   const expanded = rawSlots
//     .filter((s) => s?.isAvailable)
//     .flatMap((slot) =>
//       slot?.parentSlotId
//         ? [{
//             ...slot,
//             id: slot.id || `${slot.parentSlotId}_${String(slot.startTime)}`,
//           }]
//         : expandSlotToIndividual(slot)
//     )
//     .filter((slot) => !isToday || toMs(slot.startTime) >= nowMs)
//     .sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

//   return expanded;
// };

// export default function usePatientAvailability() {
//   const dispatch = useDispatch();

//   const [slotsByKey, setSlotsByKey]     = useState({});
//   const [loadingSlots, setLoadingSlots] = useState(false);
//   const [slotsError, setSlotsError]     = useState(null);
//   const [blockedDays, setBlockedDays]   = useState([]);
//   const [eventDays, setEventDays]       = useState([]);

//   const loadSlots = useCallback(
//     async (medecinId, date) => {
//       if (!medecinId || !date) return null;
//       const formattedDate = typeof date === "string" ? date : utcDayKey(date);
//       const key = `${medecinId}|${formattedDate}`;
//       setLoadingSlots(true);
//       setSlotsError(null);
//       try {
//         const [result, blockedResult, eventsResult] = await Promise.all([
//           dispatch(fetchDoctorAvailableSlotsByDate({ medecinId, date: formattedDate })).unwrap(),
//           dispatch(fetchBlockedSlots({ medecinId, date: formattedDate }))
//             .unwrap()
//             .catch((e) => {
//               console.warn("[usePatientAvailability] fetchBlockedSlots failed:", e);
//               return null;
//             }),
//           dispatch(fetchEventsByDoctor(medecinId))
//             .unwrap()
//             .catch((e) => {
//               console.warn("[usePatientAvailability] fetchEventsByDoctor failed:", e);
//               return null;
//             }),
//         ]);
//         const allBlocked = extractBlockedSlots(blockedResult);
//         setBlockedDays(allBlocked);
//         const blockedForDate = getBlockedForDate(allBlocked, formattedDate);

//         // ── Events ─────────────────────────────────────────────────────────
//         const allEvents = extractEvents(eventsResult);
//         setEventDays(allEvents);
//         const eventsForDate = getEventsForDate(allEvents, formattedDate);

//         // ── Expand + filtres ───────────────────────────────────────────────
//         const expanded = extractAndExpandSlots(result, formattedDate);

//         setSlotsByKey((prev) => ({ ...prev, [key]: expanded }));
//         return expanded;

//       } catch (err) {
//         console.error("[usePatientAvailability] Error loadSlots:", err);
//         setSlotsError(err);
//         throw err;
//       } finally {
//         setLoadingSlots(false);
//       }
//     },
//     [dispatch]
//   );

//   return {
//     slotsByKey,
//     loadingSlots,
//     slotsError,
//     loadSlots,
//     blockedDays,
//     eventDays,
//   };
// }

"use client";

import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { fetchDoctorAvailableSlotsByDate, fetchBlockedSlots } from "../../availabilityDoctor/redux/thunks/disponibilityThunks";
import { fetchEventsByDoctor } from "../../availabilityDoctor/redux/thunks/eventsThunks";

/* ===== Helpers ===== */

// ─── FIX CRITIQUE : Utilise la date LOCALE, pas UTC ──────────────────────────
// L'ancienne version (Date.UTC) produisait une date décalée selon le fuseau horaire.
// Ex : le 29 mai à 23h en Tunisie (UTC+1) → UTC donnait "2026-05-30" → mauvaise clé.
const utcDayKey = (dateObj) => {
  if (!(dateObj instanceof Date)) return "";
  return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(
    dateObj.getDate()
  ).padStart(2, "0")}`;
};

const parseAsLocal = (isoString) => {
  if (!isoString) return null;
  const value = String(isoString);
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatAsLocalDateTime = (date) => {
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};

const toMs = (isoString) => {
  const d = parseAsLocal(isoString);
  return d ? d.getTime() : null;
};

// ─── Expanse un slot parent en sous-créneaux individuels ─────────────────────
// Ex: slot 10:00-18:00 avec slotDuration=45 → [10:00, 10:45, 11:30, ...]
export const expandSlotToIndividual = (slot) => {
  if (!slot?.startTime || !slot?.endTime || !slot?.slotDuration) return [];
  const duration = Number(slot.slotDuration);
  if (!duration || duration <= 0) return [];

  const start = parseAsLocal(slot.startTime);
  const end   = parseAsLocal(slot.endTime);
  if (!start || !end || start >= end) return [];

  const results = [];
  let cursor = new Date(start);

  while (cursor < end) {
    const slotEnd = new Date(cursor.getTime() + duration * 60 * 1000);
    if (slotEnd > end) break;
    results.push({
      ...slot,
      id: `${slot.id}_${formatAsLocalDateTime(cursor)}`,
      // Slots are compared as local wall-clock times. Serializing them to UTC
      // here and parsing them as local again shifts every slot by the timezone.
      startTime: formatAsLocalDateTime(cursor),
      endTime: formatAsLocalDateTime(slotEnd),
      isAvailable: slot.isAvailable ?? true,
    });
    cursor = slotEnd;
  }
  return results;
};

// ─── Vérifie si un slot est couvert par un blocage ───────────────────────────
const isSlotCoveredByBlock = (slotStartISO, blockedSlots) => {
  if (!blockedSlots?.length) return false;
  const slotMs = toMs(slotStartISO);
  if (!slotMs) return false;
  return blockedSlots.some((b) => {
    const bStartMs = toMs(b.startTime);
    const bEndMs   = toMs(b.endTime);
    if (!bStartMs || !bEndMs) return false;
    return slotMs >= bStartMs && slotMs < bEndMs;
  });
};

// ─── Vérifie si un slot chevauche un événement existant ──────────────────────
const isSlotCoveredByEvent = (slotStartISO, slotEndISO, events) => {
  if (!events?.length) return false;
  const slotStartMs = toMs(slotStartISO);
  const slotEndMs   = toMs(slotEndISO);
  if (!slotStartMs || !slotEndMs) return false;
  return events.some((e) => {
    const eStartMs = toMs(e.startTime);
    const eEndMs   = toMs(e.endTime);
    if (!eStartMs || !eEndMs) return false;
    return slotStartMs < eEndMs && slotEndMs > eStartMs;
  });
};

// ─── Extrait les blocked slots depuis toutes les structures possibles ─────────
const extractBlockedSlots = (blockedResult) => {
  if (!blockedResult) return [];


  // Format thunk : { medecinId, data: { slots: [] } }
  if (blockedResult?.data?.slots && Array.isArray(blockedResult.data.slots))
    return blockedResult.data.slots;

  // Format thunk : { medecinId, data: [] }
  if (blockedResult?.data && Array.isArray(blockedResult.data))
    return blockedResult.data;

  // Format direct : { slots: [] }
  if (Array.isArray(blockedResult?.slots))
    return blockedResult.slots;

  // Format direct : []
  if (Array.isArray(blockedResult))
    return blockedResult;

  // Format nested : { data: { data: { slots: [] } } }
  if (blockedResult?.data?.data?.slots && Array.isArray(blockedResult.data.data.slots))
    return blockedResult.data.data.slots;

  if (blockedResult?.data?.data && Array.isArray(blockedResult.data.data))
    return blockedResult.data.data;

  // Format payload
  if (blockedResult?.payload?.data?.slots && Array.isArray(blockedResult.payload.data.slots))
    return blockedResult.payload.data.slots;

  if (blockedResult?.payload?.data && Array.isArray(blockedResult.payload.data))
    return blockedResult.payload.data;

  if (Array.isArray(blockedResult?.payload))
    return blockedResult.payload;

  console.warn("🔴 extractBlockedSlots: aucun format reconnu:", JSON.stringify(blockedResult));
  return [];
};

// ─── Extrait les events depuis toutes les structures possibles ────────────────
const extractEvents = (eventsResult) => {
  if (!eventsResult) return [];
  if (Array.isArray(eventsResult))               return eventsResult;
  if (Array.isArray(eventsResult.data))          return eventsResult.data;
  if (Array.isArray(eventsResult?.data?.events)) return eventsResult.data.events;
  if (Array.isArray(eventsResult?.events))       return eventsResult.events;
  return [];
};

// ─── Filtre les events pour une date donnée ───────────────────────────────────
const getEventsForDate = (allEvents, formattedDate) => {
  const dayStart = parseAsLocal(`${formattedDate}T00:00:00`).getTime();
  const dayEnd   = parseAsLocal(`${formattedDate}T23:59:59`).getTime();
  return allEvents.filter((e) => {
    if (!e?.startTime) return false;
    const eStart = toMs(e.startTime);
    const eEnd   = e.endTime ? toMs(e.endTime) : eStart;
    return eStart <= dayEnd && eEnd >= dayStart;
  });
};

// ─── Filtre les blocked slots pour une date donnée ────────────────────────────
const getBlockedForDate = (allBlocked, formattedDate) => {
  const dayStart = parseAsLocal(`${formattedDate}T00:00:00`).getTime();
  const dayEnd   = parseAsLocal(`${formattedDate}T23:59:59`).getTime();
  return allBlocked.filter((b) => {
    if (!b?.startTime) return false;
    const bStart = toMs(b.startTime);
    const bEnd   = b.endTime ? toMs(b.endTime) : bStart;
    return bStart <= dayEnd && bEnd >= dayStart;
  });
};

// ─── Extrait, expanse et filtre les slots ─────────────────────────────────────
const extractAndExpandSlots = (result, requestedDate) => {
  if (!result) return [];
  let rawSlots = [];
  if (Array.isArray(result))                                rawSlots = result;
  else if (Array.isArray(result.slots))                     rawSlots = result.slots;
  else if (result.data && Array.isArray(result.data.slots)) rawSlots = result.data.slots;
  else if (result.data && Array.isArray(result.data))       rawSlots = result.data;
  const now = new Date();
  const isToday = requestedDate === utcDayKey(now);
  const nowMs = now.getTime();
  const expanded = rawSlots
    .filter((s) => s?.isAvailable)
    .flatMap((slot) =>
      slot?.parentSlotId
        ? [{
            ...slot,
            id: slot.id || `${slot.parentSlotId}_${String(slot.startTime)}`,
          }]
        : expandSlotToIndividual(slot)
    )
    .filter((slot) => !isToday || toMs(slot.startTime) >= nowMs)
    .sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

  return expanded;
};

export default function usePatientAvailability() {
  const dispatch = useDispatch();

  const [slotsByKey, setSlotsByKey]     = useState({});
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [slotsError, setSlotsError]     = useState(null);
  const [blockedDays, setBlockedDays]   = useState([]);
  const [eventDays, setEventDays]       = useState([]);

  const loadSlots = useCallback(
    async (medecinId, date) => {
      if (!medecinId || !date) return null;
      const formattedDate = typeof date === "string" ? date : utcDayKey(date);
      const key = `${medecinId}|${formattedDate}`;
      setLoadingSlots(true);
      setSlotsError(null);
      try {
        const [result, blockedResult, eventsResult] = await Promise.all([
          dispatch(fetchDoctorAvailableSlotsByDate({ medecinId, date: formattedDate })).unwrap(),
          dispatch(fetchBlockedSlots({ medecinId, date: formattedDate }))
            .unwrap()
            .catch((e) => {
              console.warn("[usePatientAvailability] fetchBlockedSlots failed:", e);
              return null;
            }),
          dispatch(fetchEventsByDoctor(medecinId))
            .unwrap()
            .catch((e) => {
              console.warn("[usePatientAvailability] fetchEventsByDoctor failed:", e);
              return null;
            }),
        ]);
        const allBlocked = extractBlockedSlots(blockedResult);
        setBlockedDays(allBlocked);
        const blockedForDate = getBlockedForDate(allBlocked, formattedDate);

        // ── Events ─────────────────────────────────────────────────────────
        const allEvents = extractEvents(eventsResult);
        setEventDays(allEvents);
        const eventsForDate = getEventsForDate(allEvents, formattedDate);

        // ── Expand + filtres ───────────────────────────────────────────────
        const expanded = extractAndExpandSlots(result, formattedDate);

        setSlotsByKey((prev) => ({ ...prev, [key]: expanded }));
        return expanded;

      } catch (err) {
        console.error("[usePatientAvailability] Error loadSlots:", err);
        setSlotsError(err);
        throw err;
      } finally {
        setLoadingSlots(false);
      }
    },
    [dispatch]
  );

  return {
    slotsByKey,
    loadingSlots,
    slotsError,
    loadSlots,
    blockedDays,
    eventDays,
  };
}